import Vue from 'vue'
import Router from 'vue-router'
import * as act from '../store/actions'
import * as mut from '../store/mutations'
import Store from '../store'
import { isRouteUserFacing } from '@/utils/routeHelpers'
import loadChunk from '@/utils/loadChunk'
import { FRONTEND_APP_TYPE, BACKEND_APP_TYPE } from '@/config/appTypes'

const BucketsPage = () =>
  loadChunk(import(/* webpackChunkName: "BucketsPage" */ '@/components/pages/BucketsPage'))

const DebugPage = () =>
  loadChunk(import(/* webpackChunkName: "DebugPage" */ '@/components/pages/DebugPage'))
const FeatureIncentivePage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "FeatureIncentivePage" */ '@/components/pages/FeatureIncentivePage'
    ),
  )

const KPIDashboardPage = () =>
  loadChunk(
    import(/* webpackChunkName: "KPIDashboardPage" */ '@/components/pages/KPIDashboardPage'),
  )
const DashboardPage = () =>
  loadChunk(import(/* webpackChunkName: "DashboardPage" */ '@/components/pages/DashboardPage'))
const CpuProfilingPage = () =>
  loadChunk(
    import(/* webpackChunkName: "CpuProfilingPage" */ '@/components/pages/CpuProfilingPage'),
  )
const HeapProfilingPage = () =>
  loadChunk(
    import(/* webpackChunkName: "HeapProfilingPage" */ '@/components/pages/HeapProfilingPage'),
  )
const ProfilePage = () =>
  loadChunk(import(/* webpackChunkName: "ProfilePage" */ '@/components/pages/ProfilePage'))
const MemProfilingPage = () =>
  loadChunk(
    import(/* webpackChunkName: "MemProfilingPage" */ '@/components/pages/MemProfilingPage'),
  )
const NotificationsPage = () =>
  loadChunk(
    import(/* webpackChunkName: "NotificationsPage" */ '@/components/pages/NotificationsPage'),
  )
const BillingPage = () =>
  loadChunk(import(/* webpackChunkName: "BillingPage" */ '@/components/pages/BillingPage'))
const BillingInformationsPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "BillingInformationsPage" */ '@/components/pages/BillingInformationsPage'
    ),
  )
const BillingPlansPage = () =>
  loadChunk(
    import(/* webpackChunkName: "BillingPlansPage" */ '@/components/pages/BillingPlansPage'),
  )
const BillingCardsPage = () =>
  loadChunk(
    import(/* webpackChunkName: "BillingCardsPage" */ '@/components/pages/BillingCardsPage'),
  )
const BillingSepaPage = () =>
  loadChunk(import(/* webpackChunkName: "BillingSepaPage" */ '@/components/pages/BillingSepaPage'))
const BillingReceiptsPage = () =>
  loadChunk(
    import(/* webpackChunkName: "BillingReceiptsPage" */ '@/components/pages/BillingReceiptsPage'),
  )
// const IssuesPage = () =>
//   loadChunk(
//     import(/* webpackChunkName: "IssuesPageSimple" */ '@/components/pages/IssuesPageSimple')
//   )
const IssueListPage = () =>
  loadChunk(import(/* webpackChunkName: "IssueListPage" */ '@/components/pages/IssueListPage'))
const IssuePage = () =>
  loadChunk(import(/* webpackChunkName: "IssuePage" */ '@/components/pages/IssuePage'))
const IssuesSettingsPage = () =>
  loadChunk(
    import(/* webpackChunkName: "IssuesSettingsPage" */ '@/components/pages/IssuesSettingsPage'),
  )
const ActionsCenterPage = () =>
  loadChunk(
    import(/* webpackChunkName: "ActionsCenterPage" */ '@/components/pages/ActionsCenterPage'),
  )
const DistributedTracingPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "DistributedTracingPage" */ '@/components/pages/DistributedTracingPage'
    ),
  )
const TeamPage = () =>
  loadChunk(import(/* webpackChunkName: "TeamPage" */ '@/components/pages/TeamPage'))
const MetricsHistogramsPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "MetricsHistogramsPage" */ '@/components/pages/MetricsHistogramsPage'
    ),
  )
const AppsOverviewPage = () =>
  loadChunk(
    import(/* webpackChunkName: "AppsOverviewPage" */ '@/components/pages/AppsOverviewPage'),
  )
const FrontendAppsOverviewPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "FrontendAppsOverviewPage" */ '@/components/pages/FrontendAppsOverviewPage'
    ),
  )
const ProcessesOverviewPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "ProcessesOverviewPage" */ '@/components/pages/ProcessesOverviewPage'
    ),
  )
const AlertingPage = () =>
  loadChunk(import(/* webpackChunkName: "AlertingPage" */ '@/components/pages/AlertingPage'))
const SettingsPage = () =>
  loadChunk(import(/* webpackChunkName: "SettingsPage" */ '@/components/pages/SettingsPage'))
const LogsPage = () =>
  loadChunk(import(/* webpackChunkName: "LogsPage" */ '@/components/pages/LogsPage'))
const AnomaliesPage = () =>
  loadChunk(import(/* webpackChunkName: "AnomaliesPage" */ '@/components/pages/AnomaliesPage'))
const AnomaliesSettingsPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "AnomaliesSettingsPage" */ '@/components/pages/AnomaliesSettingsPage'
    ),
  )
const DisabledBucketPage = () =>
  loadChunk(
    import(/* webpackChunkName: "DisabledBucketPage" */ '@/components/pages/DisabledBucketPage'),
  )
const FrontendMonitoringDisabledPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "FrontendMonitoringDisabledPage" */ '@/components/pages/FrontendMonitoringDisabledPage'
    ),
  )
// Webchecks
const WebchecksPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "WebchecksSettingsPage" */ '@/components/pages/webchecks/WebchecksPage'
    ),
  )
const WebchecksSettingsListPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "WebchecksSettingsListPage" */ '@/components/pages/webchecks/WebchecksSettingsListPage'
    ),
  )
const WebchecksSettingsEditPage = () =>
  loadChunk(
    import(
      /* webpackChunkName: "WebchecksSettingsEditPage" */ '@/components/pages/webchecks/WebchecksSettingsEditPage'
    ),
  )

Vue.use(Router)

export const BUCKETS_PAGE = 'BUCKETS_PAGE'
export const APPS_OVERVIEW_PAGE = 'APPS_OVERVIEW_PAGE'
export const DEBUG_PAGE = 'DEBUG_PAGE'
export const FEATURE_INCENTIVE_PAGE = 'FEATURE_INCENTIVE_PAGE'
export const FRONTEND_APPS_OVERVIEW_PAGE = 'FRONTEND_APPS_OVERVIEW_PAGE'
export const USER_PROFILE_PAGE = 'USER_PROFILE_PAGE'
export const BUCKET_META_PAGE = 'BUCKET_META_PAGE'
export const BUCKET_FEATURE_PAGES = 'BUCKET_FEATURE_PAGES'
export const DISABLED_BUCKET_PAGE = 'DISABLED_BUCKET_PAGE'
export const PROCESSES_OVERVIEW_PAGE = 'PROCESSES_OVERVIEW_PAGE'
export const KPI_DASHBOARD_PAGE = 'KPI_DASHBOARD_PAGE'
export const SETTINGS_META_PAGE = 'SETTINGS_META_PAGE'
export const SETTINGS_PAGE = 'SETTINGS_PAGE'
export const NOTIFICATIONS_PAGE = 'NOTIFICATIONS_PAGE'
export const BILLING_META_PAGE = 'BILLING_META_PAGE'
export const BILLING_INFORMATIONS_PAGE = 'BILLING_INFORMATIONS_PAGE'
export const BILLING_PLANS_PAGE = 'BILLING_PLANS_PAGE'
export const BILLING_CARDS_PAGE = 'BILLING_CARDS_PAGE'
export const BILLING_SEPA_PAGE = 'BILLING_SEPA_PAGE'
export const BILLING_RECEIPTS_PAGE = 'BILLING_RECEIPTS_PAGE'
export const TEAM_PAGE = 'TEAM_PAGE'
export const DASHBOARD_PAGE = 'DASHBOARD_PAGE'
export const METRICS_HISTOGRAM_PAGE = 'METRICS_HISTOGRAM_PAGE'
export const GLOBAL_ISSUE_LIST_PAGE = 'GLOBAL_ISSUE_LIST_PAGE'
export const GLOBAL_ISSUE_PAGE = 'GLOBAL_ISSUE_PAGE'
export const GLOBAL_ISSUES_SETTINGS_PAGE = 'GLOBAL_ISSUES_SETTINGS_PAGE'
export const ISSUE_LIST_PAGE = 'ISSUE_LIST_PAGE'
export const ISSUE_PAGE = 'ISSUE_PAGE'
export const ISSUES_SETTINGS_PAGE = 'ISSUES_SETTINGS_PAGE'
export const LOGS_PAGE = 'LOGS_PAGE'
export const ACTIONS_CENTER_PAGE = 'ACTIONS_CENTER_PAGE'
export const DISTRIBUTED_TRACING_PAGE = 'DISTRIBUTED_TRACING_PAGE'
export const CPU_PROFILING_PAGE = 'CPU_PROFILING_PAGE'
export const HEAP_PROFILING_PAGE = 'HEAP_PROFILING_PAGE'
export const MEM_PROFILING_PAGE = 'MEM_PROFILING_PAGE'
export const ALERTING_PAGE = 'ALERTING_PAGE'
export const ANOMALIES_PAGE = 'ANOMALIES_PAGE'
export const ANOMALIES_SETTINGS_PAGE = 'ANOMALIES_SETTINGS_PAGE'
export const FRONTEND_MONITORING_DISABLED_PAGE = 'FRONTEND_MONITORING_DISABLED_PAGE'
// Webchecks
export const WEBCHECKS_PAGE = 'WEBCHECKS_PAGE'
export const WEBCHECKS_SETTINGS_LIST_PAGE = 'WEBCHECKS_SETTINGS_LIST_PAGE'
export const WEBCHECKS_SETTINGS_EDIT_PAGE = 'WEBCHECKS_SETTINGS_EDIT_PAGE'
export const WEBCHECKS_SETTINGS_CREATE_PAGE = 'WEBCHECKS_SETTINGS_CREATE_PAGE'

const PageGroup = {
  props: {
    getKey: Function,
  },
  render(createElement) {
    const key = this.getKey && this.getKey(this.$route)
    return createElement('router-view', { key })
  },
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: BUCKETS_PAGE,
      component: BucketsPage,
      meta: {
        title: 'Buckets',
        icon: 'km-icon-buckets-list',
      },
    },
    {
      path: '/profile',
      name: USER_PROFILE_PAGE,
      component: ProfilePage,
      meta: {
        title: 'User Profile',
        icon: 'km-icon-profile',
      },
    },
    {
      path: '*',
      redirect: '/',
      meta: {
        hide: true,
      },
    },
    {
      path: '/r/:bucketPublicId',
      beforeEnter(to, from, next) {
        for (const bucketState of Object.values(Store.state.buckets)) {
          if (bucketState.bucket.public_id === to.params.bucketPublicId) {
            next({
              name: BUCKET_META_PAGE,
              params: { id: bucketState.bucket.id },
            })
            return
          }
        }

        next({
          name: BUCKETS_PAGE,
        })
      },
      meta: {
        hide: true,
      },
    },
    {
      path: '/bucket/:id',
      name: BUCKET_META_PAGE,
      component: PageGroup,
      redirect: to => {
        return { name: BUCKET_FEATURE_PAGES }
      },
      meta: {
        showWhenBucketDisabled: true,
        hideFromMenu: true,
      },
      props: {
        getKey(route) {
          if (route.meta.requireApp) {
            return `${route.params.id}-${route.query.app}`
          } else {
            return route.params.id
          }
        },
      },
      children: [
        {
          path: 'disabled',
          name: DISABLED_BUCKET_PAGE,
          component: DisabledBucketPage,
          meta: {
            title: 'Disabled Bucket',
            showOnlyWhenBucketDisabled: true,
            icon: 'km-icon-bucket',
            abstract:
              'The current bucket is disabled, but you can re-enable it by subscribing to a paying plan',
            doc: null,
          },
        },

        {
          path: 'frontend-disabled',
          name: FRONTEND_MONITORING_DISABLED_PAGE,
          component: FrontendMonitoringDisabledPage,
          meta: {
            title: 'Frontend Monitoring',
            icon: 'km-icon-bucket',
          },
        },

        // Bucket Meta Namespace
        {
          path: 'meta',
          name: SETTINGS_META_PAGE,
          component: PageGroup,
          redirect: '/bucket/:id/meta/general',
          meta: {
            title: 'Settings',
            icon: 'km-icon-settings',
            showWhenBucketDisabled: true,
            hideFromMenu: true,
            abstract: 'Setting page for this bucket.',
            doc: null,
          },
          children: [
            {
              path: 'general',
              name: SETTINGS_PAGE,
              component: SettingsPage,
              meta: {
                title: 'General',
                icon: 'km-icon-bucket',
                showWhenBucketDisabled: true,
                abstract: 'General configuration page for this Bucket.',
                doc: null,
              },
            },
            {
              path: 'billing',
              name: BILLING_META_PAGE,
              component: BillingPage,
              redirect: 'billing/informations',
              meta: {
                title: 'Billing',
                icon: 'km-icon-billing',
                showWhenBucketDisabled: true,
                hideWhenDedicated: true,
                abstract:
                  'Select your Plan, update your card, get your receipts and update billing informations.',
                doc: null,
              },
              children: [
                {
                  path: 'informations',
                  name: BILLING_INFORMATIONS_PAGE,
                  component: BillingInformationsPage,
                  meta: {
                    title: 'Billing Informations',
                    icon: 'km-icon-anomalies',
                    showWhenBucketDisabled: true,
                  },
                },
                {
                  path: 'plans',
                  name: BILLING_PLANS_PAGE,
                  component: BillingPlansPage,
                  meta: {
                    title: 'Billing Plans',
                    icon: 'km-icon-plans',
                    showWhenBucketDisabled: true,
                  },
                },
                {
                  path: 'cards',
                  name: BILLING_CARDS_PAGE,
                  component: BillingCardsPage,
                  meta: {
                    title: 'Billing Cards',
                    icon: 'km-icon-cards',
                    showWhenBucketDisabled: true,
                  },
                },
                {
                  path: 'sepa',
                  name: BILLING_SEPA_PAGE,
                  component: BillingSepaPage,
                  meta: {
                    title: 'Billing Sepa',
                    icon: 'km-icon-cards',
                    featureId: 'sepaPayment',
                    skipIncentive: true,
                    showWhenBucketDisabled: true,
                  },
                },
                {
                  path: 'receipts',
                  name: BILLING_RECEIPTS_PAGE,
                  component: BillingReceiptsPage,
                  meta: {
                    title: 'Billing Receipts',
                    icon: 'km-icon-receipt',
                    showWhenBucketDisabled: true,
                  },
                },
              ],
            },
            {
              path: 'team',
              name: TEAM_PAGE,
              component: TeamPage,
              meta: {
                title: 'Team',
                icon: 'km-icon-team',
                abstract: 'List and handle your team members who have access to your bucket.',
                screen: 'plus/team/team.png',
                doc: null,
              },
            },
            {
              path: 'anomalies',
              name: ANOMALIES_SETTINGS_PAGE,
              component: AnomaliesSettingsPage,
              meta: {
                title: 'Anomalies',
                icon: 'km-icon-anomalies',
                featureId: 'analyzer',
                hideIfNoFeature: true,
                abstract:
                  'Control the sensitivity of our algorithm and exlude apps, servers and metrics from the detection',
                doc: null,
              },
            },
          ],
        },

        {
          path: ':appType',
          name: BUCKET_FEATURE_PAGES,
          component: PageGroup,
          redirect(to) {
            const plan = Store.getters.bucketPlan(to.params.id)
            const appType = to.params.appType || BACKEND_APP_TYPE

            let name
            if (appType === BACKEND_APP_TYPE) {
              if (plan && plan.id === 'enterprise') {
                name = APPS_OVERVIEW_PAGE
              } else {
                name = PROCESSES_OVERVIEW_PAGE
              }
            } else {
              name = FRONTEND_APPS_OVERVIEW_PAGE
            }

            return { name, params: { id: to.params.id, appType } }
          },
          meta: {},
          children: [
            {
              path: 'debug',
              name: DEBUG_PAGE,
              component: DebugPage,
              meta: {
                title: 'Debug',
                icon: 'km-icon-issues',
                hideFromMenu: true,
                appTypes: [BACKEND_APP_TYPE, FRONTEND_APP_TYPE],
              },
            },

            {
              path: 'feature/:incentiveId',
              name: FEATURE_INCENTIVE_PAGE,
              component: FeatureIncentivePage,
              meta: {
                title: 'Feature',
                icon: 'km-icon-issues',
                hideFromMenu: true,
                appTypes: [BACKEND_APP_TYPE, FRONTEND_APP_TYPE],
              },
            },

            {
              path: 'overview/servers',
              name: PROCESSES_OVERVIEW_PAGE,
              component: ProcessesOverviewPage,
              meta: {
                title: 'Processes Overview',
                icon: 'km-icon-servers',
                appTypes: [BACKEND_APP_TYPE],
                abstract: 'Get an eagle view by listing of all your servers running pm2.',
                doc: 'plus/overview',
              },
            },
            {
              path: 'overview/apps',
              name: APPS_OVERVIEW_PAGE,
              component: AppsOverviewPage,
              meta: {
                title: 'Apps Overview',
                icon: 'km-icon-apps',
                appTypes: [BACKEND_APP_TYPE],
                featureId: 'appsOverviewPage',
                abstract:
                  "This is a 'pm2 ls' across servers. This will give you a app centric overview across all your servers.",
                doc: 'plus/overview',
                screen: 'enterprise/overview/overview.png',
              },
            },
            {
              path: 'apps',
              name: FRONTEND_APPS_OVERVIEW_PAGE,
              component: FrontendAppsOverviewPage,
              meta: {
                title: 'Frontend Monitoring',
                icon: 'km-icon-apps',
                appTypes: [FRONTEND_APP_TYPE],
                abstract:
                  'Monitor your Javascript FrontEnd application:<br/>- Track Javascript Errors<br/>- Replay User Sessions<br/>- Track UX rage clicks, page refresh<br/>- Track Performance Metrics',
                doc: 'enterprise/frontend-monitoring/overview',
                screen: 'plus/frontend/frontend.png',
              },
            },
            {
              path: 'issues-overview',
              meta: {},
              component: PageGroup,
              children: [
                {
                  path: '/',
                  name: GLOBAL_ISSUE_LIST_PAGE,
                  component: IssueListPage,
                  meta: {
                    title: 'Issues Overview',
                    skipIncentive: true,
                    icon: 'km-icon-issues',
                    appTypes: [BACKEND_APP_TYPE],
                    featureId: 'exceptions',
                    abstract:
                      "Error tracking that helps monitor and fix crashes in real-time.<br/>- Smart notification system to avoid spam<br/>- Real time interface updates<br/>- Contextual error informations<br/>- <a href='http://doc.pm2.io/en/plus/guide/custom-actions/' target='_blank'>Plug your own</a> custom alerts",
                    doc: 'plus/guide/issue-dashboard',
                  },
                  props: {
                    appFilter: true,
                  },
                },
                {
                  path: 'settings',
                  name: GLOBAL_ISSUES_SETTINGS_PAGE,
                  component: IssuesSettingsPage,
                  meta: {
                    title: 'Issues Settings',
                    icon: 'km-icon-issues',
                    hideFromMenu: true,
                    appTypes: [BACKEND_APP_TYPE],
                  },
                },
                {
                  path: ':issueId',
                  name: GLOBAL_ISSUE_PAGE,
                  component: IssuePage,
                  meta: {
                    title: 'Issue',
                    icon: 'km-icon-issues',
                    appTypes: [BACKEND_APP_TYPE],
                  },
                },
              ],
            },
            {
              path: 'dashboards/:dashboardId?',
              name: KPI_DASHBOARD_PAGE,
              component: KPIDashboardPage,
              meta: {
                title: 'Dashboards',
                icon: 'km-icon-kpi-dashboard',
                featureId: 'kpi',
                appTypes: [BACKEND_APP_TYPE],
                abstract:
                  "The perfect sidekick for PM2 Plus' overview. Whereas the former gives you all the metrics that you need, the Dashboards lets you focus on the metrics that matter to you and your team, and on how to display them.",
                doc: 'enterprise/guides/dashboard',
                screen: 'enterprise/dashboards/dashboards.png',
              },
            },
            {
              path: 'anomalies',
              name: ANOMALIES_PAGE,
              component: AnomaliesPage,
              meta: {
                title: 'Anomalies',
                icon: 'km-icon-anomalies',
                featureId: 'analyzer',
                appTypes: [BACKEND_APP_TYPE],
                abstract:
                  'Automatically detect metrics behavior correlation, detect unexpected anomalies. This feature is in R&D.',
                doc: null,
                screen: 'enterprise/anomalies/anomalies.png',
              },
            },
            {
              path: 'alerting',
              name: ALERTING_PAGE,
              component: AlertingPage,
              meta: {
                title: 'Alerting',
                icon: 'km-icon-alerting',
                featureId: 'alerts',
                appTypes: [BACKEND_APP_TYPE],
                abstract:
                  'Create your own alerts by setting different type of threshold on any metrics. Automatically trigger emails, slack notifications, webhooks, custom actions or SMS.',
                doc: 'enterprise/guides/alerting',
                screen: 'enterprise/alerting/alerting.png',
              },
            },
            {
              path: 'webchecks',
              meta: {},
              component: PageGroup,
              children: [
                {
                  path: '/',
                  name: WEBCHECKS_PAGE,
                  component: WebchecksPage,
                  meta: {
                    title: 'Webchecks',
                    hideWhenDedicated: true,
                    icon: 'km-icon-webchecks',
                    featureId: 'webchecks',
                    appTypes: [BACKEND_APP_TYPE],
                    abstract: 'Visualize your network health accross the world',
                    doc: 'enterprise/guides/webchecks',
                    screen: 'enterprise/webchecks/webcheck.png',
                  },
                },
                {
                  path: 'list',
                  name: WEBCHECKS_SETTINGS_LIST_PAGE,
                  component: WebchecksSettingsListPage,
                  meta: {
                    title: 'Webchecks List',
                    hideFromMenu: true,
                    appTypes: [BACKEND_APP_TYPE],
                  },
                },
                {
                  path: 'create',
                  name: WEBCHECKS_SETTINGS_CREATE_PAGE,
                  component: WebchecksSettingsEditPage,
                  meta: {
                    title: 'Create Webcheck',
                    hideFromMenu: true,
                    appTypes: [BACKEND_APP_TYPE],
                  },
                },
                {
                  path: ':webcheckId',
                  name: WEBCHECKS_SETTINGS_EDIT_PAGE,
                  component: WebchecksSettingsEditPage,
                  meta: {
                    title: 'Edit Webcheck',
                    hideFromMenu: true,
                    featureId: 'webchecks',
                    appTypes: [BACKEND_APP_TYPE],
                  },
                },
              ],
            },
            {
              path: 'transaction-tracing',
              name: DISTRIBUTED_TRACING_PAGE,
              component: DistributedTracingPage,
              meta: {
                title: 'Distributed Tracing',
                icon: 'km-icon-transaction-tracing',
                featureId: 'distributedTracing',
                appTypes: [BACKEND_APP_TYPE],
                abstract:
                  'Make your API faster. Detect which API route is slow, Identify slow database queries or 3rd party service interactions. Monitor API status code over time.',
                doc: 'enterprise/guides/distributed-tracing',
                screen: 'enterprise/distributed_tracing/distributed_tracing.png',
              },
            },
            {
              path: 'notifications',
              name: NOTIFICATIONS_PAGE,
              component: NotificationsPage,
              meta: {
                title: 'Notifications',
                icon: 'km-icon-alerts',
                featureId: 'notifications',
                appTypes: [BACKEND_APP_TYPE],
                abstract: 'Configure your email and third party Notification (slack, webhook,..)',
                screen: 'plus/notifications/notification.png',
                doc: null,
              },
            },

            {
              path: 'dashboard',
              name: DASHBOARD_PAGE,
              component: DashboardPage,
              meta: {
                title: 'App Dashboard',
                icon: 'km-icon-dashboard',
                featureId: 'appDashboardPage',
                requireApp: true,
                appTypes: [BACKEND_APP_TYPE],
                abstract:
                  "Get an overview of your app's health over the last week. Display your most important metrics in realtime.",
                doc: 'plus/overview',
                screen: 'enterprise/dashboard/dashboard.png',
              },
            },
            {
              path: 'metrics-histograms',
              name: METRICS_HISTOGRAM_PAGE,
              component: MetricsHistogramsPage,
              meta: {
                get title() {
                  return Store.getters.hasFeature({ feature: 'metrics' })
                    ? this.byFeature.metrics.title
                    : this.byFeature.realtimeMetricsPage.title
                },
                featureId: ['metrics', 'realtimeMetricsPage'],
                byFeature: {
                  realtimeMetricsPage: {
                    title: 'Realtime Metrics',
                  },
                  metrics: {
                    title: 'Metrics Histograms',
                  },
                },
                icon: 'km-icon-metrics-histograms',
                requireApp: true,
                appTypes: [BACKEND_APP_TYPE, FRONTEND_APP_TYPE],
                abstract:
                  "Understand how your application behaves over time. Monitor inputs, outputs and processings.<br/>- Detect memory leaks, server saturation.<br/>- Monitor active connections.<br/>- <a href='http://doc.pm2.io/en/plus/guide/custom-actions/' target='_blank'>Custom Monitor any metric</a> easily.",
                doc: 'plus/guide/configuration/#expose-custom-metrics',
                screen: 'enterprise/histograms/histograms.png',
              },
            },
            {
              path: 'issues',
              meta: {
                requireApp: true,
              },
              component: PageGroup,
              children: [
                {
                  path: '/',
                  name: ISSUE_LIST_PAGE,
                  component: IssueListPage,
                  meta: {
                    get title() {
                      return Store.getters.hasFeature({ feature: 'exceptions' })
                        ? this.byFeature.exceptions.title
                        : this.byFeature.realtimeIssuesPage.title
                    },
                    featureId: ['exceptions', 'realtimeIssuesPage'],
                    byFeature: {
                      exceptions: {
                        title: 'Historical Issues',
                      },
                      realtimeIssuesPage: {
                        title: 'Realtime Issues',
                      },
                    },
                    icon: 'km-icon-issues',
                    requireApp: true,
                    appTypes: [BACKEND_APP_TYPE, FRONTEND_APP_TYPE],
                    abstract:
                      "Error tracking that helps monitor and fix crashes in real-time.<br/>- Smart notification system to avoid spam<br/>- Real time interface updates<br/>- Contextual error informations<br/>- <a href='http://doc.pm2.io/en/plus/guide/custom-actions/' target='_blank'>Plug your own</a> custom alerts",
                    doc: 'plus/guide/issue-dashboard',
                    screen: 'enterprise/issues/issues.png',
                  },
                },
                {
                  path: 'settings',
                  name: ISSUES_SETTINGS_PAGE,
                  component: IssuesSettingsPage,
                  meta: {
                    title: 'Issues Settings',
                    icon: 'km-icon-issues',
                    hideFromMenu: true,
                    requireApp: true,
                    appTypes: [BACKEND_APP_TYPE, FRONTEND_APP_TYPE],
                    abstract: 'Exclude issues',
                    doc: 'plus/guide/issue-dashboard',
                    screen: 'enterprise/issues/issues.png',
                  },
                },
                {
                  path: ':issueId',
                  name: ISSUE_PAGE,
                  component: IssuePage,
                  meta: {
                    title: 'Issue',
                    icon: 'km-icon-issues',
                    requireApp: true,
                    appTypes: [BACKEND_APP_TYPE, FRONTEND_APP_TYPE],
                  },
                },
              ],
            },
            {
              path: 'logs',
              name: LOGS_PAGE,
              component: LogsPage,
              meta: {
                get title() {
                  return Store.getters.hasFeature({ feature: 'logs' })
                    ? this.byFeature.logs.title
                    : this.byFeature.realtimeLogsPage.title
                },
                byFeature: {
                  realtimeLogsPage: {
                    title: 'Realtime Logs',
                    abstract:
                      'Consult logs of all your applications in real-time within the same interface.',
                    screen: 'plus/logs/logs.png',
                  },
                  logs: {
                    title: 'Historical Logs',
                    abstract:
                      'Stop going back and forth to your servers and display your applications logs directly in your browser.',
                    screen: 'enterprise/logs/logs.png',
                  },
                },
                icon: 'km-icon-logs',
                requireApp: true,
                featureId: ['logs', 'realtimeLogsPage'],
                appTypes: [BACKEND_APP_TYPE],
                doc: 'enterprise/guides/log',
              },
            },
            {
              path: 'cpu',
              name: CPU_PROFILING_PAGE,
              component: CpuProfilingPage,
              meta: {
                title: 'CPU Profiling',
                icon: 'km-icon-cpu-profiling',
                featureId: 'profiling',
                requireApp: true,
                appTypes: [BACKEND_APP_TYPE],
                abstract:
                  'No more time wasted trying to reproduce CPU overflows. With this <i>in-situ</i> CPU Profiling system, start profiling your application, straight in production. Inspect the resulting flamechart to detect cpu demanding function calls.',
                doc: 'plus/guide/cpu-profiling',
                screen: 'enterprise/cpu_profiling/cpu_profiling.png',
              },
            },
            {
              path: 'mem',
              name: HEAP_PROFILING_PAGE,
              component: HeapProfilingPage,
              meta: {
                title: 'Memory Profiling',
                icon: 'km-icon-memory-profiling',
                featureId: 'heapprofile',
                requireApp: true,
                appTypes: [BACKEND_APP_TYPE],
                abstract:
                  'Trigger a Memory profiling of your app on one or more servers. Inspect the resulting timeline view to see from where objects were allocated.',
                doc: null,
                screen: 'enterprise/heap_profiling/view.png',
              },
            },
            {
              path: 'mem-snapshot',
              name: MEM_PROFILING_PAGE,
              component: MemProfilingPage,
              meta: {
                title: 'Memory Snapshot',
                icon: 'km-icon-memory-snapshot',
                featureId: 'profiling',
                requireApp: true,
                appTypes: [BACKEND_APP_TYPE],
                abstract:
                  'Trigger a Memory snapshot of your app on one or more servers. Inspect the resulting bubble chart to detect what objects retain the most memory.',
                doc: 'plus/guide/memory-profiling',
                screen: 'enterprise/heap_snapshot/heap_snapshot.png',
              },
            },
            {
              path: 'actions-center',
              name: ACTIONS_CENTER_PAGE,
              component: ActionsCenterPage,
              meta: {
                title: 'Remote Actions',
                icon: 'km-icon-actions-center',
                requireApp: true,
                appTypes: [BACKEND_APP_TYPE],
                featureId: 'remoteActionsPage',
                abstract:
                  'Restart, Reload, Reset your application from this interface. <a href="http://doc.pm2.io/en/plus/guide/custom-actions/" target="_blank">Expose Javascript functions</a> and trigger them from here.',
                doc: 'plus/guide/configuration/#exose-remote-actions',
                screen: 'plus/actionCenter/actionCenter.png',
              },
            },
          ],
        },
      ],
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  // Ensure critial resources are fetched before rendering anything
  const actions = []
  if (!Store.getters.areCriticalResourcesFetched) {
    actions.push(
      Promise.all([
        Store.dispatch(act.FETCH_PLANS),
        Store.dispatch(act.FETCH_USER),
        Store.dispatch(act.FETCH_BUCKETS),
      ]).then(() => {
        Store.commit(mut.SET_CRITICAL_RESOURCES_FETCHED, { areCriticalResourcesFetched: true })
      }),
    )
  }

  const isBucketRoute = to.params.id !== undefined
  if (isBucketRoute && to.params.id !== Store.state.currentBucketId) {
    Store.commit(mut.SET_PAGE_LOADING, { isPageLoading: true })
    actions.push(Store.dispatch(act.SET_CURRENT_BUCKET, { bucketId: to.params.id }))
  }

  if (actions.length) {
    try {
      await Promise.all(actions)
    } catch (e) {
      Store.dispatch(act.DISPLAY_NOTIFICATION, {
        type: 'error',
        message: 'Failed to load the page. Please retry later.',
      })
      Store.commit(mut.SET_PAGE_LOADING, { isPageLoading: false })
      next({ name: BUCKETS_PAGE })
      return
    }
  }

  const finalDestination = redirectPage(to)

  // Show the "loading" when the page changes because it may take a while to lazy-load the page
  // sources
  const finalDestinationName = finalDestination ? finalDestination.name : to.name
  Store.commit(mut.SET_PAGE_LOADING, { isPageLoading: finalDestinationName !== from.name })

  next(finalDestination)
})

router.beforeResolve((to, from, next) => {
  Store.commit(mut.SET_PAGE_TITLE, { title: null })
  next()
  setTimeout(() => {
    Store.commit(mut.SET_PAGE_LOADING, { isPageLoading: false })
  }, 1)
})

function redirectPage(to) {
  // Check if the user have access to this page
  if (to.params.id && isRouteUserFacing(to) === false) {
    return {
      name: BUCKET_META_PAGE,
      params: { id: to.params.id },
    }
  }

  // Check if the frontend monitoring is enabled
  if (
    to.params.appType === FRONTEND_APP_TYPE &&
    !Store.getters.hasFeature({ feature: 'frontend' })
  ) {
    return { name: FRONTEND_MONITORING_DISABLED_PAGE, params: { id: to.params.id } }
  }

  // Don't show the FRONTEND_MONITORING_DISABLED_PAGE if the frontend monitoring is enabled
  if (
    to.name === FRONTEND_MONITORING_DISABLED_PAGE &&
    Store.getters.hasFeature({ feature: 'frontend' })
  ) {
    return {
      name: FRONTEND_APPS_OVERVIEW_PAGE,
      params: { id: to.params.id, appType: FRONTEND_APP_TYPE },
    }
  }

  // Check if the app is found
  if (to.meta.requireApp) {
    const notFound = appNotFoundRoute(to)
    if (notFound) {
      return notFound
    } else {
      Store.commit(mut.SET_CURRENT_APP_NAME, { appName: to.query.app })
    }
  }
}

function appNotFoundRoute(route) {
  if (!route.params.id) return // should not happen
  const appName = route.query.app
  if (appName) {
    const currentBucket = Store.getters.currentBucket
    // TODO handle appType
    if (
      !currentBucket ||
      currentBucket.processes.some(p => p.name === appName) ||
      Store.getters.frontendApps.some(application => application.name === appName)
    ) {
      return
    }
  }

  // If the app is not found, go to the BUCKET_META_PAGE
  return {
    name: BUCKET_META_PAGE,
    params: { id: route.params.id },
  }
}

// URL hash to path migration: we used to have the Vue router configured to use URL hashes for the
// route.  If we load the page with a hash looking like a route (= starting with a '/'), set the URL
// path to the hash instead.
if (location.hash.startsWith('#/')) {
  history.replaceState(undefined, undefined, location.hash.slice(1))
}

export default router
